import { render, staticRenderFns } from "./IseqDatafieldList.vue?vue&type=template&id=0bc816fd&scoped=true"
import script from "./IseqDatafieldList.vue?vue&type=script&lang=js"
export * from "./IseqDatafieldList.vue?vue&type=script&lang=js"
import style0 from "./IseqDatafieldList.vue?vue&type=style&index=0&id=0bc816fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc816fd",
  null
  
)

export default component.exports